export default __webpack_public_path__ + "static/media/textlayer_weight.6aec584c.jpg";